import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Heading,
  useColorModeValue,
  Text,
  useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import CustomToast from '../../common/CustomToast';
import PassDownloadTemplateContext from '../../store/client/PassDownloadTemplateContext';
import { useContext } from 'react';

const RemoveLanguageModal = ({
  isOpen,
  onClose,
  selectedLanguage,
  setEditingLang,
}) => {
  const { handleSubmit, formState } = useForm();
  const { isSubmitting } = formState;
  const passDownloadCtx = useContext(PassDownloadTemplateContext);

  const modeBoxBg = useColorModeValue('white', 'secondaryDark');
  const modeTextBg = useColorModeValue('white', 'primaryDark06');
  const modeLabelBg = useColorModeValue('white', 'primaryDark03');
  const modeOffset = useColorModeValue('0', '16px !important');

  const toast = useToast();

  const onSubmit = async () => {
    passDownloadCtx.removeTranslation(selectedLanguage);
    setEditingLang(null);

    toast({
      render: ({ onClose }) => (
        <CustomToast
          status="success"
          title="Language successfully removed"
          description=""
          onClose={onClose}
        />
      ),
    });
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      closeOnOverlayClick={false}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent bg={modeBoxBg} p="10px" borderRadius="15px">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            bg={modeTextBg}
            pb={modeOffset}
            borderRadius="15px 15px 0 0"
          >
            <Heading>Remove language</Heading>
          </ModalHeader>
          <ModalBody bg={modeLabelBg}>
            <Text fontSize="16px" mt="10px">
              Are you sure you want to remove this language?
            </Text>
            <Text fontSize="15px">
              All translations for this language will be lost.
            </Text>
          </ModalBody>
          <ModalFooter display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="secondary" size="sm" onClick={onClose}>
              <Text>Cancel</Text>
            </Button>
            <Button
              type="submit"
              alt="OK"
              fontSize="14px"
              h="36px"
              width={{ base: 'full', sm: 'auto' }}
              isLoading={isSubmitting}
            >
              Remove
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};
export default RemoveLanguageModal;
